import type { Server, UserInfo } from '@forest/paywall-core'

// Production splits by `userInfo.server` (`global` vs `china`). Staging and
// dev each have a single cluster, so the `dev` and `staging` cells hold the
// same id the campaign uses on those clusters.
export const ACTIVITY_ID_BY_SERVER: Record<Server, number> = {
  dev: 68,
  staging: 68,
  global: 72,
  china: 79,
}

export function getActivityId(userInfo: UserInfo): number {
  return ACTIVITY_ID_BY_SERVER[userInfo.server]
}
